var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
export default function Main(_a) {
    var children = _a.children;
    return _jsx(Container, { children: children });
}
var Container = styled.main(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 100%;\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 100%;\n"])));
var templateObject_1;
